import { Card, CardHeader, CardTitle } from "@buddy/ui";
import { createFileRoute } from "@tanstack/react-router";
import { MemoryBrowser } from "@/features/memory/memory-browser";
import { useOrg } from "@/lib/org";

export const Route = createFileRoute("/_app/_main/notebook")({ component: Notebook });

// The shared team notes every employee reads, in the same browser as an employee's Memory tab.
function Notebook() {
  const org = useOrg();
  return (
    <Card className="flex-1">
      <CardHeader>
        <CardTitle>Team notebook</CardTitle>
      </CardHeader>
      <MemoryBrowser
        sections={[{ key: "team", label: `${org.name} notebook`, owner: { scope: "team", employeeId: null }, icon: "people" }]}
        footer="Every employee reads these notes and may add to them. Anything you change here, they read before their next task."
      />
    </Card>
  );
}
